import Vue from 'vue';
import App from './App.vue';
import router from './router';
import i18n from './i18n';
import VueResource from 'vue-resource';
import vuetify from './plugins/vuetify';
import lang from './lang';

Vue.use(VueResource);

Vue.config.productionTip = false;

i18n.locale = lang.getLang();

Vue.http.options.root = process.env.VUE_APP_API_PATH;
Vue.http.interceptors.push((request, next) => {
  request.headers.set('Accept', 'application/json');
  request.headers.set('Accept-Language', lang.getLang());
  next(res => {});
});

new Vue({
  router,
  i18n,
  vuetify,
  render: h => h(App)
}).$mount('#app');
